import Loading from '@/components/loading/skeleton';
import { useGetDataVolume } from '../hooks/useGetDataVolume';
import VolumeProgressCard from '../VolumeProgressCard';
import MilestoneItem from './MilestoneItem';

const MilestonesLoading = () => {
    return (
        <div className="gap-2 mx-4 flex flex-col gap-y-2">
            {[1, 2, 3, 4].map((item) => (
                <Loading isLoading={true} className=" h-[60px]" key={item}>
                    <></>
                </Loading>
            ))}
        </div>
    );
};

export default function Volume() {
    const { milestones, currentVolume, isLoading } = useGetDataVolume();

    return (
        <>
            <VolumeProgressCard />

            {/* Danh sách Milestones */}

            {isLoading && <MilestonesLoading />}
            {!isLoading && (
                <div className="mx-4 pr-4 relative">
                    {milestones?.map((milestone) => (
                        <MilestoneItem
                            key={milestone.id}
                            currentVolume={currentVolume || 0}
                            milestone={milestone}
                        />
                    ))}
                </div>
            )}
        </>
    );
}
